// @flow
export const requiredText = 'This field is mandatory';
